import {
  Backdrop,
  Box,
  Divider,
  IconButton,
  Modal,
  Typography
} from "@mui/material";
import React from "react";
import { BCPXmark } from "../../../components/icons/bcp/BCPIcons";
import MarkdownViewer from "../../../components/utilities/MarkdownViewer";

// Admin-only "Scorecard Description" menu item (BCP-411/414): surfaces both the TO-facing
// public description and the support/admin-only internal description for the scorecard a
// pairing is actually using, without cluttering the pairing screen itself.
export default function ScorecardDescriptionModal(props) {
  const { open, setOpen, scorecard } = props;

  return (
    <Modal
      disableAutoFocus
      open={Boolean(open)}
      onClose={() => setOpen(false)}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500
      }}
      sx={{ zIndex: 9999 }}
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: ["95vw", "85vw", 600],
          maxHeight: "95vh",
          overflowY: "auto",
          bgcolor: "modal.background",
          color: "modal.text",
          border: "1px solid rgba(0, 0, 0, 0.12)",
          borderRadius: 1,
          boxShadow: 24,
          p: 4,
          textAlign: "left"
        }}
      >
        <IconButton
          aria-label="cancel"
          color="error"
          sx={{ position: "absolute", top: "4px", right: "4px" }}
          onClick={() => setOpen(false)}
        >
          <BCPXmark />
        </IconButton>

        <Typography variant="h5" component="h2" gutterBottom>
          {scorecard?.name || "Scorecard Description"}
        </Typography>

        <Divider sx={{ my: 2 }} />

        <Typography variant="subtitle1" fontWeight="700" gutterBottom>
          Description
        </Typography>
        <Typography variant="body1" sx={{ whiteSpace: "pre-wrap", mb: 2 }}>
          {scorecard?.publicDescription ||
            "No description available for this scorecard yet."}
        </Typography>

        <Divider sx={{ my: 2 }} />

        <Typography variant="subtitle1" fontWeight="700" gutterBottom>
          Internal Description (support/admin only)
        </Typography>
        {scorecard?.internalDescription ? (
          <MarkdownViewer source={scorecard.internalDescription} />
        ) : (
          <Typography variant="body1" color="text.secondary">
            No internal description available for this scorecard yet.
          </Typography>
        )}
      </Box>
    </Modal>
  );
}
